import {aMinutesMillisecond, TIME_PER_STEP} from "../../../../util/varibles/constants";

export const getNewStart = (activity_log: any) => {
    const startOld = activity_log[0].est_start_time;
    const duration = Math.ceil((Date.now() - startOld + (15 * aMinutesMillisecond)) / TIME_PER_STEP) * TIME_PER_STEP;
    return duration > 0 ? startOld + duration : startOld;
}
